export default __webpack_public_path__ + "static/sumbul-siddiqui-49b50599117d6992ac3698a9ce2e2006.webp";